import type { SensitiveFieldsConfig } from '../types/masking.types';

export function applyMasking<T extends Record<string, unknown>>(properties: T | undefined, sensitiveFields: SensitiveFieldsConfig): T | undefined {
  if (!properties) return properties;

  if (Object.keys(sensitiveFields).length === 0) return properties;

  const result = { ...properties };

  for (const [key, value] of Object.entries(result)) {
    if (typeof value === 'string' && sensitiveFields[key]) {
      (result as Record<string, unknown>)[key] = sensitiveFields[key](value);
    }
  }

  return result;
}
